"use client"

import { ChevronDown } from "lucide-react"
import Link from "next/link"
import * as React from "react"
import MenuContent from "./components/MenuContent"


export const dataLinkCategory = [
    {
        title: "مردانه",
        src: "/categories/mens-perfume",
        children: [
            {
                title: "مردانه تلخ",
                src: "/categories/bitter-mens-perfume",
            },
            {
                title: "مردانه معتدل",
                src: "/categories/moderate-mens-perfume",
            },
            {
                title: "مردانه خنک",
                src: "/categories/cool-mens-perfume",
            },
            {
                title: "مردانه ترش",
                src: "/categories/sour-mens-perfume",
            },
            {
                title: "مردانه شیرین",
                src: "/categories/sweet-mens-perfume",
            },
            {
                title: "مردانه تند",
                src: "/categories/spicy-mens-perfume",
            },
        ]
    },
    {
        title: "زنانه",
        src: "/categories/womens-perfume",
        children: [
            {
                title: "زنانه تلخ",
                src: "/categories/bitter-womens-perfume",
            },
            {
                title: "زنانه معتدل",
                src: "/categories/moderate-womens-perfume",
            },
            {
                title: "زنانه خنک",
                src: "/categories/cool-womens-perfume",
            },
            {
                title: "زنانه ترش",
                src: "/categories/sour-womens-perfume",
            },
            {
                title: "زنانه شیرین",
                src: "/categories/sweet-womens-perfume",
            },
            {
                title: "زنانه تند",
                src: "/categories/spicy-womens-perfume",
            },
        ]
    },
    {
        title: "اورجینال",
        src: "/categories/عطر?page=1&type=1",
        children: [
            {
                title: " اورجینال تلخ",
                src: "/categories/عطر?page=1&type=1&attr=[33]",
            },
            {
                title: " اورجینال معتدل",
                src: "/categories/عطر?page=1&type=1&attr=[30]",
            },
            {
                title: " اورجینال خنک",
                src: "/categories/عطر?page=1&type=1&attr=[28]",
            },
            {
                title: " اورجینال گرم",
                src: "/categories/عطر?page=1&type=1&attr=[29]",
            },
            {
                title: " اورجینال ترش",
                src: "/categories/عطر?page=1&type=1&attr=[36]",
            },
            {
                title: " اورجینال شیرین",
                src: "/categories/عطر?page=1&type=1&attr=[34]",
            },
            {
                title: " اورجینال تند",
                src: "/categories/عطر?page=1&type=1&attr=[35]",
            },
        ]
    },
    {
        title: "شرکتی",
        src: "/categories/عطر?page=1&type=2",
        children: [
            {
                title: " شرکتی تلخ",
                src: "/categories/عطر?page=1&type=2&attr=[33]",
            },
            {
                title: " شرکتی معتدل",
                src: "/categories/عطر?page=1&type=2&attr=[30]",
            },
            {
                title: " شرکتی خنک",
                src: "/categories/عطر?page=1&type=2&attr=[28]",
            },
            {
                title: " شرکتی گرم",
                src: "/categories/عطر?page=1&type=2&attr=[29]",
            },
            {
                title: " شرکتی ترش",
                src: "/categories/عطر?page=1&type=2&attr=[36]",
            },
            {
                title: " شرکتی شیرین",
                src: "/categories/عطر?page=1&type=2&attr=[34]",
            },
            {
                title: " شرکتی تند",
                src: "/categories/عطر?page=1&type=2&attr=[35]",
            },
        ]
    },
    {
        title: "مینیاتوری",
        src: "/categories/عطر?page=1&type=3",
        children: [
            {
                title: " مینیاتوری تلخ",
                src: "/categories/عطر?page=1&type=3&attr=[33]",
            },
            {
                title: " مینیاتوری معتدل",
                src: "/categories/عطر?page=1&type=3&attr=[30]",
            },
            {
                title: " مینیاتوری خنک",
                src: "/categories/عطر?page=1&type=3&attr=[28]",
            },
            {
                title: " مینیاتوری گرم",
                src: "/categories/عطر?page=1&type=3&attr=[29]",
            },
            {
                title: " مینیاتوری ترش",
                src: "/categories/عطر?page=1&type=3&attr=[36]",
            },
            {
                title: " مینیاتوری شیرین",
                src: "/categories/عطر?page=1&type=3&attr=[34]",
            },
            {
                title: " مینیاتوری تند",
                src: "/categories/عطر?page=1&type=3&attr=[35]",
            },
        ]
    },

]


const LinkHeader = () => {
    const [open, setOpen] = React.useState(false);

    return (
        <div
            className=""
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <Link
                className={`text-sm flex items-center ${open ? "text-pink font-bold" : "text-text"
                    }`}
                href="/categories/عطر"
            >
                همه عطر ها
                <ChevronDown className="size-4 ml-1" />
            </Link>
            <div
                 className={`absolute left-1/2 transform -translate-x-1/2 transition-opacity duration-300 ${
                    open ? "opacity-100 visible" : "opacity-0 invisible"
                  }`}
            >
                <MenuContent />
            </div>
        </div>
    );
}



export default LinkHeader